// Anonymous per-device owner token used for blog comments & reactions.
const KEY = 'ere_blog_owner_v1';

export function getOwnerToken(): string {
  if (typeof window === 'undefined') return 'ssr';
  let t = localStorage.getItem(KEY);
  if (!t) {
    t = (crypto.randomUUID?.() || Math.random().toString(36).slice(2)) + Date.now().toString(36);
    localStorage.setItem(KEY, t);
  }
  return t;
}
